let UUID = 1;
import { api } from "../apis/main.js";
import { notify } from "../utils/toast.js";

export const Getid = () => {
  UUID++;
  return UUID;
};

export const SetThousand = (val = 0) => {
  const num = +val || "";
  const parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const Delay = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve("delay: " + time);
    }, time);
  });
};

export const Uuid = () => {
  return Math.random().toString(16).slice(2);
};

export const OnResize = (fn = () => {}) => {
  // window resize
  const menuClick = Rx.Observable.fromEvent($(".open-close"), "click");
  const resize = Rx.Observable.fromEvent(window, "resize");
  Rx.Observable.merge(menuClick, resize).debounceTime(300).subscribe(fn);
};

// 舊版依賴 jquery-toast plugin（$.toast），但該 plugin 早已沒有被任何頁面載入，
// 呼叫必定拋錯。改接自建的 notify，行為與其他通知一致。
export const Toast = (params = {}) => {
  const type = ["success", "error", "warning", "info"].includes(params.icon)
    ? params.icon
    : "success";
  return notify[type](params.text || params.heading || "上傳成功");
};

export const SetTable = (table, options = {}) => {
  const {
    responsive = false,
    iDisplayLength = 10,
    order = [[0, "desc"]],
    pageingType = "simple_numbers",
    columnDefs = [],
    searching = true,
    bLengthChange = true,
    dom = "lftipr",
  } = options;

  const dlang = {
    sProcessing: "載入中...",
    sLengthMenu: "每頁 _MENU_ 筆",
    sZeroRecords: "沒有符合結果",
    sInfo: "從 _START_ 到 _END_ /共 _TOTAL_ 筆",
    sInfoEmpty: "顯示第 0 至 0 項結果，共 0 項",
    sInfoFiltered: "(過濾總筆數 _MAX_)",
    sInfoPostFix: "",
    sSearch: "搜尋:",
    sUrl: "",
    sEmptyTable: "無任何資料",
    sLoadingRecords: "載入中...",
    sInfoThousands: ",",
    oPaginate: {
      sFirst: "首頁",
      sPrevious: "上頁",
      sNext: "下頁",
      sLast: "末頁",
      sJump: "跳頁",
    },
    oAria: {
      sSortAscending: ": 以升序排列此列",
      sSortDescending: ": 以降序排列此列",
    },
  };

  // reset tooltip
  $('[data-toggle="tooltip"]').tooltip("enable");

  return $(table).DataTable({
    responsive: responsive,
    language: dlang,
    stateSave: false,
    stateDuration: 60 * 60,
    searching: searching,
    iDisplayLength: iDisplayLength,
    order: order,
    pagingType: pageingType,
    bLengthChange: bLengthChange,
    dom: dom,
    columnDefs: [
      ...columnDefs,
      { className: "text-center", orderable: false, targets: -1 },
    ],
  });
};

export const GetCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const GetQueryString = (obj) => {
  let str = [];
  for (let p in obj) {
    if (typeof obj[p] == "boolean") {
      obj[p] = obj[p].toString().toLowerCase();
    }
    if (typeof obj[p] == "number") {
      obj[p] = obj[p].toString().toLowerCase();
    }
    if (obj.hasOwnProperty(p) && !IsNullOrEmpty(obj[p])) {
      if(p === 'district_id_list') {
        obj[p].forEach((item) => {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
        });
      }else{
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    
    console.log(p);
  }
  return str.join("&");
};

export const IsNullOrEmpty = (obj) => {
  return typeof obj == "boolean" || typeof obj == "number"
    ? false
    : obj == undefined || obj == null || obj.length <= 0 || obj == "";
};

// log form data資訊
export const logFormData = (formData) => {
  for (var pair of formData.entries()) {
    console.log(pair[0] + ", " + pair[1]);
  }
  return;
};

// 取得 Query string 轉物件
export const GetQueryParams = (url) => {
  let tmp = url.substring(url.indexOf("?") + 1).split("&");
  let result = {};
  for (let i in tmp) {
    if (tmp[i].indexOf("=") > -1) {
      result[tmp[i].split("=")[0]] = tmp[i].split("=")[1];
    }
  }
  return result;
};

export const DownloadExport = (url) => {
  api
    .get(url, { responseType: "blob" })
    .catch((error) => {
      console.log(error);
      let res = error.response;
      let blob = new Blob([res.data], { type: res.headers["content-type"] });
      blob.text().then((d) => {
        toastr.info(JSON.parse(d).detail);
      });
      return;
    })
    .then((res) => {
      if (res.data) {
        let blob = new Blob([res.data], { type: res.headers["content-type"] });
        let path = window.URL.createObjectURL(blob);
        let filename = decodeURIComponent(res.headers["content-disposition"].split("=")[1]);
        let a = document.createElement("a");
        a.href = path;
        a.setAttribute("download", filename);
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
};
